export default {
  label: {
    createAcct: '创建人',
    createTime: '创建时间',
    merchantNo: '商户号',
    updateAcct: '更新人',
    updateTime: '更新时间',
    walletAmount: '钱包金额',
    walletType: '钱包类型',
    momo: 'Momo',
    zalo: 'Zalo',
    vtp: 'Viettel pay',
    vtpFix: 'Viettel pay fix',
    bankOnline: '网银',
    transfer: '转账钱包',
    bankQr: '网银扫码',
    all: '总钱包',
    card: '充值卡',
    payout: '代付钱包',
    allMerchantBalance: '商户总余额',
    todayPayoutAmount: '今日交易金额',
    todayBalanceAmount: '出款金额',
    todayTradeAmount: '余额',
    yesterdayTradeAmount: '昨日交易金额',
    usdtBalance: 'usdt钱包'
  },
  rules: {
    walletType: '钱包类型不能为空！'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/merchantBalance.js